export function numberToChinese(num) {
  const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const chineseUnits = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千']
  
  if (num === 0) return '零'
  if (num < 0) return '负' + numberToChinese(-num)
  
  let str = num.toString()
  let result = ''
  
  // 处理小数点
  if (str.includes('.')) {
    const [integerPart, decimalPart] = str.split('.')
    return numberToChinese(parseInt(integerPart)) + '点' + 
           decimalPart.split('').map(d => chineseDigits[parseInt(d)]).join('')
  }
  
  // 处理整数部分
  let zeroCount = 0
  for (let i = 0; i < str.length; i++) {
    const digit = parseInt(str[i])
    const unitIndex = str.length - i - 1
    
    if (digit === 0) {
      zeroCount++
      // 处理万、亿单位
      if (chineseUnits[unitIndex] === '万' || chineseUnits[unitIndex] === '亿') {
        result += chineseUnits[unitIndex]
      }
    } else {
      if (zeroCount > 0) {
        result += '零'
        zeroCount = 0
      }
      
      // 处理"一十"开头的情况
      if (digit === 1 && unitIndex === 1 && i === 0) {
        result += '十'
      } else {
        result += chineseDigits[digit] + chineseUnits[unitIndex]
      }
    }
  }
  
  // 清理多余的零
  result = result.replace(/零+$/, '')
  return result || '零'
}